import { BASE_URL } from '@/environment/environment'
import { useOnboardingStore } from '../stores/onboardingStore'
import type { TOnboardingSection } from '../types/TOnboardingSection'

/**
 * Адрес GET-ручки модуля: пока идёт онбординг раздела — её учебный двойник `/api/onboarding/...`
 * с тем же контрактом ответа.
 * Двойники есть не у всех ручек: передавать только пути из `apps/onboarding/features/<module>/urls.py` бека.
 * Формы и селекты сюда не переводить — учебные id нельзя отправлять в боевые ручки.
 */
export function onboardingApiUrl(section: TOnboardingSection, path: string): string {
  const isDemo = useOnboardingStore().scenario?.section === section

  return `${BASE_URL}/api${isDemo ? '/onboarding' : ''}${path}`
}

/**
 * Адрес ручки конкретной записи: для учебной записи (id из демо-данных раздела) — учебный двойник.
 * Решает id, а не идущий тур: форма, вернувшаяся к реальной записи до конца тура, ходит в боевую ручку.
 */
export function onboardingEntityApiUrl(section: TOnboardingSection, id: unknown, path: string): string {
  const isDemo = Boolean(useOnboardingStore().findDemoItem(section, id))

  return `${BASE_URL}/api${isDemo ? '/onboarding' : ''}${path}`
}
